import { render } from "./DappList.vue?vue&type=template&id=eec1741c&ts=true"
import script from "./DappList.vue?vue&type=script&lang=ts"
export * from "./DappList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__